import jstz from 'jstz';
import moment from 'moment';
// Char Date
export function ChartDateFilter(appSettings, usersService) {
  'ngInject';
  return function(input) {
    if (input === null) {
      return '';
    }
    let dateTimeFormat = appSettings.GetDateFormat();
    let currentUser = usersService.currentUser();
    let timezone;
    let zone;
    if (currentUser) {
      let claimsData = currentUser.claims.data;
      timezone = claimsData.timezone;
      if (!timezone) {
        zone = jstz.determine();
        timezone = zone.name();
      }
    } else {
      zone = jstz.determine();
      timezone = zone.name();
    }
    let output = moment(input)
      .tz(timezone)
      .format(dateTimeFormat);
    return output;
  };
}

// ChartLabel
export function ChartLabelFilter(appSettings, usersService) {
  'ngInject';
  return function(input, interval) {
    if (input === null) {
      return '';
    }
    let dateFormat = appSettings.GetDateFormat();

    let currentUser = usersService.currentUser();
    let timezone;
    let zone;
    if (currentUser) {
      let claimsData = currentUser.claims.data;
      timezone = claimsData.timezone;
      if (!timezone) {
        zone = jstz.determine();
        timezone = zone.name();
      }
    } else {
      zone = jstz.determine();
      timezone = zone.name();
    }
    if (interval !== '1day') {
      dateFormat = `${dateFormat} @ h:mm:ssA`;
    } else if (interval === '1hour') {
      dateFormat = `${dateFormat} @ hA`;
    }
    let output = moment(input)
      .tz(timezone)
      .format(dateFormat);
    return output;
  };
}
